/*globals createjs, console */

define([], function() {
    function getSceneNames(root) {
        return root.timeline._tweens
            .map(function(t) {
                return t._target;
            })
            .map(function(c) {
                var keys = Object.keys(root);
                for (var i = 0; i < keys.length; i++) {
                    if (root[keys[i]] === c) { return keys[i]; }
                }
            });
    }

    function dynamicTimeline(root, sceneList) {
        root._allScenes = getSceneNames(root);

        root.timeline._tweens.slice(0).forEach(function(tween) {
            root.timeline.removeTween(tween);
        });

        var scenes = sceneList.map(function(sceneInfo) {
            if (typeof sceneInfo == "string") { sceneInfo = { id: sceneInfo }; }
            var sceneId = sceneInfo.id;
            var clip = root[sceneId];

            if (!clip || !(clip instanceof createjs.MovieClip)) {
                console.log("dynamicTimeline: Not a valid instance ID: " + sceneId);
                return;
            }

            return {
                id: sceneInfo.id,
                inst: clip,
                duration: clip.duration,
                background: sceneInfo.background,
                loop: sceneInfo.loop,
                blocked: sceneInfo.blocked //whether the scene is blocked or not (useful for seek bar restriction)
            };
        });

        var backgroundScenes = scenes.filter(function(clipInfo) {
            return clipInfo.background;
        });
        var timelineScenes = scenes.filter(function(clipInfo) {
            return !clipInfo.background;
        });

        var duration = timelineScenes
            .map(function(s) {
                return s.duration;
            })
            .reduce(function(a, b) {
                return a + b;
            }, 0);
        var currentTime = 0;
        //var mode = createjs.MovieClip.INDEPENDENT;

        timelineScenes.forEach(function(scene) {
            var tween = createjs.Tween.get(scene.inst);
            if (currentTime !== 0) {
                scene.inst._off = true;
                tween.wait(currentTime);
            } else {
                scene.inst._off = false;
            }

            scene.startFrame = currentTime;
            tween.to({ _off: false }, 0);
            currentTime += scene.duration;
            if (currentTime < duration) {
                tween.to({ _off: true }, scene.duration);
                tween.wait(duration - currentTime);
            }
            scene.inst.parent = root;
            //scene.inst.mode = mode;
            root.timeline.addTween(tween);
        });

        backgroundScenes.forEach(function(scene) {
            scene.inst._off = false;
            scene.inst.loop = !!scene.loop;
            scene.startFrame = 0;

            scene.inst.parent = root;
            //scene.inst.mode = mode;
            root.timeline.addTween(createjs.Tween.get(scene.inst).wait(duration));
        });

        root._dynamicScenes = scenes;

        return root;
    }

    return dynamicTimeline;
});
